
<template>
  <!--卡券库-->
  <div>
    <!--删除列表时使用的是rowKey的id-->
    <x-tabula
      ref="table"
      rowKey="couponId"
      :dataSource="dataSource"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :addHandleParam="addHandleParam"
      :deleteParam="deleteParam"
      :rowSelection="false"
    >
      <template slot="opt_type" slot-scope="{row}">
        <span>{{row.type === 1 ? '优惠券' : '卡密'}}</span>
      </template>

      <template slot="opt_num" slot-scope="{row}">
        <span>{{`${row.sale}/${row.stock}`}}</span>
      </template>

      <template slot="opt_status" slot-scope="{row}">
        <div style="display: flex; align-items: center">
          <span class="circle-dot" :class="statusColor[row.status] + '-bg'"></span>
          <span>{{statusObj[row.status]}}</span>
        </div>
      </template>
    </x-tabula>
  </div>
</template>

<script>
export default {
  name: 'couponLibrary',
  data () {
    const couponType = [ // 1.优惠券, 2.卡密
      { label: '优惠券', value: 1 },
      { label: '卡密', value: 2 }
    ];
    const statusSelect = [ // 卡券状态 0.作废， 1.有效， 2.过期
      { label: '有效', value: 1 },
      { label: '过期', value: 2 },
      { label: '作废', value: 0 }
    ];
    return {
      statusColor: ['info', 'success', 'danger'],
      statusObj: ['作废', '有效', '过期'],
      searchList: [
        { props: ['name'], placeholder: '卡券名称', options: [], inputType: 'input' },
        { props: ['type'], placeholder: '类型', options: couponType, inputType: 'select' },
        { props: ['status'], placeholder: '状态', options: statusSelect, inputType: 'select' }
      ],
      tableOptList: [
        { text: '新增', icon: 'plus', permi: ['community:couponLibrary:add'] }
      ],
      rowOptList: [
        {
          text: '查看',
          handle: row => this.toDetail(row),
          permi: ['community:couponLibrary:detail']
        },
        {
          text: '作废',
          handle: row => this.disCard(row),
          rowOptDisHandle: row => row.status !== 1,
          permi: ['community:couponLibrary:discard']
        }
      ],
      columns: [
        { title: '类型', dataIndex: 'type', align: '', width: '', scopedSlots: { customRender: 'type' } },
        { title: '卡券名称', dataIndex: 'name', align: '', width: '' },
        { title: '已发放/总数', dataIndex: '', align: '', width: '', scopedSlots: { customRender: 'num' }},
        { title: '有效期', dataIndex: 'expireTime', align: '', width: '' },
        { title: '状态', dataIndex: 'status', align: '', scopedSlots: { customRender: 'status' } },
        { title: '操作', dataIndex: 'action', align: '', width: '', scopedSlots: { customRender: 'action' } }
      ],
      dataSource: [],
      searchParams: {
        name: undefined,
        type: undefined,
        status: undefined
      },
      listApi: {
        url: '/pm/coupon/list',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      },
      addHandleParam: {
        route: 'addCoupon',
        addTitle: '',
        editTitle: ''
      },
      deleteParam: {
        url: '',
        title: '',
        key: '',
        resHandle: '' // 执行完删除的回调方法
      }
    };
  },
  created () {
    this.getSelect();
  },
  methods: {
    getSelect () {
    },
    /** 查看卡券详情 */
    toDetail (row) {
      this.$router.push({
        name: 'couponDetail',
        query: {
          title: '查看卡券',
          id: row.couponId,
          status: row.status,
          type: row.type,
          name: row.name,
          expireTime: row.expireTime
        }
      });
    },
    /** 作废 */
    disCard (row) {
      this.$confirm({
        title: '该卡券下未发放的卡密将全部作废，确定继续？',
        centered: true,
        onOk: () => {
          this.$delete({
            url: `/pm/coupon/${row.couponId}`
          }).then(({ data }) => {
            this.$message.success('作废成功');
            this.$refs.table.getTableList();
          });
        }
      });
    },
    resHandle (res) {
      return res;
    },
    searchHandle (selectData) {
      return selectData;
    }
  }
};
</script>
